<div class="conversation">
  <div class="row head-conversation">
    @if (selectedConversation === null && activeUsers !== null) {
<div class="new">
      <angular2-multiselect [data]="activeUsers" [(ngModel)]="selectedReceivers" [settings]="dropdownSettings">
        <c-item>
          <ng-template let-item="item">
            {{item.NAME}} @if (displayNameList(item) !== '(') {
<i class="justify-content-end" style="color: #8d8d8d; font-size: 13px">{{displayNameList(item)}}</i>
}
          </ng-template>
        </c-item>
      </angular2-multiselect>
    </div>
}
    @if (selectedConversation !== null) {
<div class="destinataire">
      {{ this.name.join(', ')}}
      <i class="ps-3 fa-solid" style="cursor: pointer" [ngClass]="{'fa-bell-slash': !this.selectedConversation.is_active_notifications,
      'fa-bell': this.selectedConversation.is_active_notifications}" (click)="switchNotif()"
         [ngbTooltip]="selectedConversation.is_active_notifications ? 'Désactiver les notifications ?' : 'Activer les notifications ?'"></i>
      <hr>
    </div>
}
  </div>
  <div class="row messages">
    @if (selectedConversation?.messages.length === 0 || selectedConversation === null) {
<div class="d-flex align-items-center" >
      <div class="col-12 text-center">
        <p><i>Vous retrouverez votre historique de messages ici.</i></p>
      </div>
    </div>
}
    @if (selectedConversation?.messages.length !== 0 && selectedConversation !== null) {
<div class="histo" #containerHisto>
      @for (msg of this.selectedConversation?.messages; track msg) {

        <div class="desc" [ngClass]="{'otherDesc' : msg.user.id === usrService.token.id}">{{nameDesc(msg)?.NAME}}  {{msg.date_creation | date : 'dd/MM/yyyy HH:mm'}}</div>
        <div class="message" [innerHTML]="msg.contenu | addJumpLine" [ngClass]="{'otherMsg' : msg.user.id !== usrService.token.id}" [ngbTooltip]="msg.date_creation | date : 'dd/MM HH:mm'">
          {{msg.contenu}}
        </div>
      
}

    </div>
}
  </div>
  <div class="row send-new">
    <div class="input-group mb-3">
      <textarea rows="3" [(ngModel)]="textMessage"  class="form-control message-text" placeholder="Saisissez votre message ici :"
          (keyup.enter)="this.selectedConversation === null ? createNewConversation() : sendMessage()" ></textarea>
      <button class="btn btn-primary" type="button" id="button-addon2"
          [ngbTooltip]="this.selectedConversation === null ? 'Créer la conversation.' :'Envoyer le message.' "
          (click)="this.selectedConversation === null ? createNewConversation() : sendMessage()"
          [disabled]="(textMessage === '' || textMessage.trim() === '') || loadingMessage ||
          (selectedConversation === null && selectedReceivers.length === 0)">
        <i class="fa-solid fa-paper-plane" ></i>
      </button>
    </div>
  </div>
</div>


